var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticStyle: { "margin-top": "5px" } }, [
        _c(
          "div",
          {
            staticClass: "button-click-left",
            staticStyle: {
              "margin-bottom": "-20px",
              position: "relative",
              "z-index": "1",
            },
          },
          [
            _c("el-date-picker", {
              staticClass: "button-left",
              staticStyle: { width: "135px" },
              attrs: {
                type: "date",
                clearable: false,
                "value-format": "yyyy-MM-dd",
                format: "dd-MM-yyyy",
                placeholder: "Chọn ngày",
              },
              on: {
                change: function ($event) {
                  return _vm.getSearchAllAttendance()
                },
              },
              model: {
                value: _vm.dataSearch.date,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "date", $$v)
                },
                expression: "dataSearch.date",
              },
            }),
            _c(
              "el-select",
              {
                staticClass: "button-left",
                staticStyle: { width: "190px" },
                attrs: { clearable: "", placeholder: "Trạng thái" },
                on: {
                  change: function ($event) {
                    return _vm.handleChangeAbsentStatus()
                  },
                },
                model: {
                  value: _vm.dataSearch.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataSearch, "status", $$v)
                  },
                  expression: "dataSearch.status",
                },
              },
              _vm._l(_vm.attendanceStatusList, function (item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.label, value: item.value },
                })
              }),
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "input-common input-status",
                staticStyle: { width: "160px" },
                attrs: {
                  disabled:
                    _vm.dataSearch.status === false ||
                    this.dataSearch.status === "",
                  placeholder: "Trạng thái chấm công",
                  clearable: "",
                },
                on: {
                  change: function ($event) {
                    return _vm.handleChangeAttendanceStatus()
                  },
                },
                model: {
                  value: _vm.dataSearch.attendanceStatus,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataSearch, "attendanceStatus", $$v)
                  },
                  expression: "dataSearch.attendanceStatus",
                },
              },
              _vm._l(_vm.listStatus, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { value: item.value, label: item.label },
                })
              }),
              1
            ),
            _c(
              "el-input",
              {
                staticClass: "button-left",
                staticStyle: { width: "280px" },
                attrs: {
                  placeholder: "Nhập tên hoặc số điện thoại",
                  clearable: "",
                },
                on: {
                  clear: function ($event) {
                    return _vm.getSearchAllAttendance()
                  },
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.getSearchAllAttendance()
                  },
                },
                model: {
                  value: _vm.dataSearch.nameOrPhone,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataSearch, "nameOrPhone", $$v)
                  },
                  expression: "dataSearch.nameOrPhone",
                },
              },
              [
                _c("el-button", {
                  attrs: { slot: "append", icon: "el-icon-search" },
                  on: {
                    click: function ($event) {
                      return _vm.getSearchAllAttendance()
                    },
                  },
                  slot: "append",
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleClickTab },
          model: {
            value: _vm.activeTabName,
            callback: function ($$v) {
              _vm.activeTabName = $$v
            },
            expression: "activeTabName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "Chi tiết ngày", name: "detailDay" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingData,
                      expression: "loadingData",
                    },
                  ],
                  ref: "multipleTable",
                  attrs: {
                    "empty-text": _vm.textTable,
                    "element-loading-spinner": "el-icon-loading",
                    "element-loading-background": "rgba(255,255,255, 0)",
                    "highlight-current-row": "",
                    "element-loading-text": _vm.$tableLoading,
                    "max-height": _vm.$tableMaxHeight,
                    data: _vm.attendanceDetailDateList,
                    "cell-style": _vm.tableRowStyleDetail,
                    "header-cell-style": _vm.tableHeaderColor,
                    border: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", align: "center", width: "55" },
                  }),
                  _c("el-table-column", {
                    attrs: { type: "index", label: "STT", align: "center" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Họ tên",
                      prop: "infoEmployeeResponse.fullName",
                      "min-width": "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Số điện thoại",
                      prop: "infoEmployeeResponse.phone",
                      align: "center",
                      width: "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Trạng thái",
                      align: "center",
                      "min-width": "130",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            !scope.row.arrive
                              ? _c("span", [_vm._v("Chưa chấm công")])
                              : _c("span", [_vm._v("Đã chấm công")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c(
                    "el-table-column",
                    { attrs: { label: "Sáng", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "Đi làm",
                          align: "center",
                          width: "70",
                          header: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.attendanceDetail.morning
                                  ? _c("i", {
                                      staticClass: "el-icon-circle-check",
                                      staticStyle: {
                                        color: "#409eff",
                                        "font-size": "18px",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Có phép",
                          align: "center",
                          width: "70",
                          header: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.attendanceDetail.morningYes
                                  ? _c("i", {
                                      staticClass: "el-icon-circle-close",
                                      staticStyle: {
                                        color: "#f56c6c",
                                        "font-size": "18px",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Ko phép",
                          align: "center",
                          width: "70",
                          header: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.attendanceDetail.morningNo
                                  ? _c("i", {
                                      staticClass: "el-icon-error",
                                      staticStyle: {
                                        color: "#f56c6c",
                                        "font-size": "18px",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "Chiều", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "Đi làm",
                          align: "center",
                          width: "70",
                          header: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.attendanceDetail.afternoon
                                  ? _c("i", {
                                      staticClass: "el-icon-circle-check",
                                      staticStyle: {
                                        "font-size": "18px",
                                        color: "#409eff",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Có phép",
                          align: "center",
                          width: "70",
                          header: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.attendanceDetail.afternoonYes
                                  ? _c("i", {
                                      staticClass: "el-icon-circle-close",
                                      staticStyle: {
                                        color: "#f56c6c",
                                        "font-size": "18px",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Ko phép",
                          align: "center",
                          width: "70",
                          header: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.attendanceDetail.afternoonNo
                                  ? _c("i", {
                                      staticClass: "el-icon-error",
                                      staticStyle: {
                                        color: "#f56c6c",
                                        "font-size": "18px",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "Tối", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "Đi làm",
                          align: "center",
                          width: "70",
                          header: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.attendanceDetail.evening
                                  ? _c("i", {
                                      staticClass: "el-icon-circle-check",
                                      staticStyle: {
                                        "font-size": "18px",
                                        color: "#409eff",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Có phép",
                          align: "center",
                          width: "70",
                          header: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.attendanceDetail.eveningYes
                                  ? _c("i", {
                                      staticClass: "el-icon-circle-close",
                                      staticStyle: {
                                        color: "#f56c6c",
                                        "font-size": "18px",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Ko phép",
                          align: "center",
                          width: "70",
                          header: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.attendanceDetail.eveningNo
                                  ? _c("i", {
                                      staticClass: "el-icon-error",
                                      staticStyle: {
                                        color: "#f56c6c",
                                        "font-size": "18px",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c("el-table-column", {
                    attrs: { label: "Giờ đến", width: "70", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatTime")(
                                    scope.row.attendanceDetail.arriveTime
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Giờ về", width: "70", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatTime")(
                                    scope.row.attendanceDetail.leaveTime
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Đến muộn(phút)",
                      width: "115",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.attendanceDetail.minuteArriveLate > 0
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.attendanceDetail
                                        .minuteArriveLate
                                    )
                                  ),
                                ])
                              : _c("span"),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Về sớm(phút)",
                      width: "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.attendanceDetail.minuteLeaveSoon > 0
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.attendanceDetail.minuteLeaveSoon
                                    )
                                  ),
                                ])
                              : _c("span"),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Tác vụ",
                      fixed: "right",
                      width: "200",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: scope.row.arrive ? false : true,
                                  size: "mini",
                                  type: "success",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleShowDetailDate(
                                      scope.$index,
                                      scope.row
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("button.view")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.checkInformationAI(
                                      scope.$index,
                                      scope.row
                                    )
                                  },
                                },
                              },
                              [_vm._v("Kiểm tra AI\n            ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { float: "right", margin: "15px 0" } },
                [
                  _c(
                    "el-dropdown",
                    { on: { command: _vm.handleCommandAction } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "button-bottom",
                          attrs: { type: "success" },
                        },
                        [
                          _vm._v("\n            Tác vụ\n            "),
                          _c("i", { staticClass: "el-icon-caret-bottom" }),
                        ]
                      ),
                      _c(
                        "el-dropdown-menu",
                        { staticClass: "el-dropdown-menu-container" },
                        [
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "exportDay" } },
                            [_vm._v("Xuất theo ngày\n            ")]
                          ),
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "exportMonth" } },
                            [_vm._v("Xuất theo tháng\n            ")]
                          ),
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "exportAll" } },
                            [_vm._v("Xuất tổng hợp\n            ")]
                          ),
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "exportMonthDetail" } },
                            [
                              _vm._v(
                                "\n              Xuất file chi tiết\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.checkPermission(["attendanceEmployee_attendance_update"])
            ? _c(
                "el-tab-pane",
                { attrs: { label: "Chấm công đến", name: "attendanceArrive" } },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingData,
                          expression: "loadingData",
                        },
                      ],
                      ref: "multipleTable",
                      attrs: {
                        "empty-text": _vm.textTableArrive,
                        "element-loading-text": _vm.$tableLoading,
                        "element-loading-spinner": "el-icon-loading",
                        "element-loading-background": "rgba(255,255,255, 0)",
                        "highlight-current-row": "",
                        data: _vm.responseArriveList,
                        "cell-style": _vm.tableRowStyle,
                        "header-cell-style": _vm.tableHeaderColor,
                        "max-height": _vm.$tableMaxHeight,
                        border: "",
                      },
                      on: {
                        "selection-change": _vm.handleSelectionChangeArrive,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          align: "center",
                          width: "55",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "STT",
                          align: "center",
                          width: "50",
                          fixed: "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "attendanceInfoEmployee.fullName",
                          label: "Họ tên",
                          "min-width": "120",
                          fixed: "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "attendanceInfoEmployee.phone",
                          label: "Số điện thoại",
                          width: "100",
                        },
                      }),
                      _c(
                        "el-table-column",
                        { attrs: { label: "Sáng", align: "center" } },
                        [
                          _c("el-table-column", {
                            attrs: { align: "center", width: "60" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "second-title" },
                                        [_vm._v("Đi làm")]
                                      ),
                                      _c("br"),
                                      _c("el-checkbox", {
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeAllMorning(
                                              scope.$index,
                                              1
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.checkboxAllMorning1,
                                          callback: function ($$v) {
                                            _vm.checkboxAllMorning1 = $$v
                                          },
                                          expression: "checkboxAllMorning1",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-checkbox", {
                                        attrs: {
                                          disabled:
                                            scope.row.attendanceConfig
                                              .morning == true
                                              ? false
                                              : true,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.checkRowMorningDay(
                                              1,
                                              scope.row
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            scope.row.arriveEmployeeDate
                                              .morning,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.arriveEmployeeDate,
                                              "morning",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.arriveEmployeeDate.morning",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3748611116
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center", width: "60" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "second-title" },
                                        [_vm._v("Có phép")]
                                      ),
                                      _c("br"),
                                      _c("el-checkbox", {
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeAllMorning(
                                              scope.$index,
                                              2
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.checkboxAllMorning2,
                                          callback: function ($$v) {
                                            _vm.checkboxAllMorning2 = $$v
                                          },
                                          expression: "checkboxAllMorning2",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-checkbox", {
                                        attrs: {
                                          disabled:
                                            scope.row.attendanceConfig
                                              .morning == true
                                              ? false
                                              : true,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.checkRowMorningDay(
                                              2,
                                              scope.row
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            scope.row.arriveEmployeeDate
                                              .morningYes,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.arriveEmployeeDate,
                                              "morningYes",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.arriveEmployeeDate.morningYes",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              566949865
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center", width: "60" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "second-title" },
                                        [_vm._v("Ko phép")]
                                      ),
                                      _c("br"),
                                      _c("el-checkbox", {
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeAllMorning(
                                              scope.$index,
                                              3
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.checkboxAllMorning3,
                                          callback: function ($$v) {
                                            _vm.checkboxAllMorning3 = $$v
                                          },
                                          expression: "checkboxAllMorning3",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-checkbox", {
                                        attrs: {
                                          disabled:
                                            scope.row.attendanceConfig
                                              .morning == true
                                              ? false
                                              : true,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.checkRowMorningDay(
                                              3,
                                              scope.row
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            scope.row.arriveEmployeeDate
                                              .morningNo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.arriveEmployeeDate,
                                              "morningNo",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.arriveEmployeeDate.morningNo",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2891380530
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-table-column",
                        { attrs: { label: "Chiều", align: "center" } },
                        [
                          _c("el-table-column", {
                            attrs: { align: "center", width: "60" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "second-title" },
                                        [_vm._v("Đi làm")]
                                      ),
                                      _c("br"),
                                      _c("el-checkbox", {
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeAllAfternoon(
                                              scope.$index,
                                              1
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.checkboxAllAfternoon1,
                                          callback: function ($$v) {
                                            _vm.checkboxAllAfternoon1 = $$v
                                          },
                                          expression: "checkboxAllAfternoon1",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-checkbox", {
                                        attrs: {
                                          disabled:
                                            scope.row.attendanceConfig
                                              .afternoon == true
                                              ? false
                                              : true,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.checkRowAfternoonDay(
                                              1,
                                              scope.row
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            scope.row.arriveEmployeeDate
                                              .afternoon,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.arriveEmployeeDate,
                                              "afternoon",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.arriveEmployeeDate.afternoon",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4105907286
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center", width: "60" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "second-title" },
                                        [_vm._v("Có phép")]
                                      ),
                                      _c("br"),
                                      _c("el-checkbox", {
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeAllAfternoon(
                                              scope.$index,
                                              2
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.checkboxAllAfternoon2,
                                          callback: function ($$v) {
                                            _vm.checkboxAllAfternoon2 = $$v
                                          },
                                          expression: "checkboxAllAfternoon2",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-checkbox", {
                                        attrs: {
                                          disabled:
                                            scope.row.attendanceConfig
                                              .afternoon == true
                                              ? false
                                              : true,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.checkRowAfternoonDay(
                                              2,
                                              scope.row
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            scope.row.arriveEmployeeDate
                                              .afternoonYes,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.arriveEmployeeDate,
                                              "afternoonYes",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.arriveEmployeeDate.afternoonYes",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3290364371
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center", width: "60" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "second-title" },
                                        [_vm._v("Ko phép")]
                                      ),
                                      _c("br"),
                                      _c("el-checkbox", {
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeAllAfternoon(
                                              scope.$index,
                                              3
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.checkboxAllAfternoon3,
                                          callback: function ($$v) {
                                            _vm.checkboxAllAfternoon3 = $$v
                                          },
                                          expression: "checkboxAllAfternoon3",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-checkbox", {
                                        attrs: {
                                          disabled:
                                            scope.row.attendanceConfig
                                              .afternoon == true
                                              ? false
                                              : true,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.checkRowAfternoonDay(
                                              3,
                                              scope.row
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            scope.row.arriveEmployeeDate
                                              .afternoonNo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.arriveEmployeeDate,
                                              "afternoonNo",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.arriveEmployeeDate.afternoonNo",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2575367304
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-table-column",
                        { attrs: { label: "Tối", align: "center" } },
                        [
                          _c("el-table-column", {
                            attrs: { align: "center", width: "60" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "second-title" },
                                        [_vm._v("Đi làm")]
                                      ),
                                      _c("br"),
                                      _c("el-checkbox", {
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeAllEvening(
                                              scope.$index,
                                              1
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.checkboxAllEvening1,
                                          callback: function ($$v) {
                                            _vm.checkboxAllEvening1 = $$v
                                          },
                                          expression: "checkboxAllEvening1",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-checkbox", {
                                        attrs: {
                                          disabled:
                                            scope.row.attendanceConfig
                                              .evening == true
                                              ? false
                                              : true,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.checkRowEveningDay(
                                              1,
                                              scope.row
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            scope.row.arriveEmployeeDate
                                              .evening,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.arriveEmployeeDate,
                                              "evening",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.arriveEmployeeDate.evening",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2598870282
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center", width: "60" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "second-title" },
                                        [_vm._v("Có phép")]
                                      ),
                                      _c("br"),
                                      _c("el-checkbox", {
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeAllEvening(
                                              scope.$index,
                                              2
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.checkboxAllEvening2,
                                          callback: function ($$v) {
                                            _vm.checkboxAllEvening2 = $$v
                                          },
                                          expression: "checkboxAllEvening2",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-checkbox", {
                                        attrs: {
                                          disabled:
                                            scope.row.attendanceConfig
                                              .evening == true
                                              ? false
                                              : true,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.checkRowEveningDay(
                                              2,
                                              scope.row
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            scope.row.arriveEmployeeDate
                                              .eveningYes,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.arriveEmployeeDate,
                                              "eveningYes",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.arriveEmployeeDate.eveningYes",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3579280143
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center", width: "60" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "second-title" },
                                        [_vm._v("Ko phép")]
                                      ),
                                      _c("br"),
                                      _c("el-checkbox", {
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeAllEvening(
                                              scope.$index,
                                              3
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.checkboxAllEvening3,
                                          callback: function ($$v) {
                                            _vm.checkboxAllEvening3 = $$v
                                          },
                                          expression: "checkboxAllEvening3",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-checkbox", {
                                        attrs: {
                                          disabled:
                                            scope.row.attendanceConfig
                                              .evening == true
                                              ? false
                                              : true,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.checkRowEveningDay(
                                              3,
                                              scope.row
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            scope.row.arriveEmployeeDate
                                              .eveningNo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.arriveEmployeeDate,
                                              "eveningNo",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.arriveEmployeeDate.eveningNo",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3981866196
                            ),
                          }),
                        ],
                        1
                      ),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "Giờ đến",
                          width: "132",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  !scope.row.arriveEmployeeDate.morning &&
                                  !scope.row.arriveEmployeeDate.afternoon &&
                                  !scope.row.arriveEmployeeDate.evening
                                    ? _c("el-time-picker", {
                                        staticStyle: { width: "85%" },
                                        attrs: {
                                          type: "time",
                                          "value-format": "HH:mm",
                                          format: "HH:mm",
                                          clearable: false,
                                          size: "mini",
                                          disabled: "",
                                          "picker-options": {
                                            selectableRange:
                                              "00:00:00 - 23:59:00",
                                          },
                                          placeholder: "Chọn",
                                        },
                                        model: {
                                          value:
                                            scope.row.arriveEmployeeDate
                                              .arriveTime,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.arriveEmployeeDate,
                                              "arriveTime",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.arriveEmployeeDate.arriveTime",
                                        },
                                      })
                                    : _c("el-time-picker", {
                                        staticStyle: { width: "85%" },
                                        attrs: {
                                          type: "time",
                                          "value-format": "HH:mm",
                                          clearable: false,
                                          format: "HH:mm",
                                          size: "mini",
                                          "picker-options": {
                                            selectableRange:
                                              "00:00:00 - 23:59:00",
                                          },
                                          placeholder: "Chọn",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeTimeLeaveCustom(
                                              scope.row
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            scope.row.arriveEmployeeDate
                                              .arriveTime,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.arriveEmployeeDate,
                                              "arriveTime",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.arriveEmployeeDate.arriveTime",
                                        },
                                      }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          793085444
                        ),
                      }),
                      _c("el-table-column", {
                        staticClass: "second-title",
                        attrs: {
                          label: "Đi muộn(Phút)",
                          width: "130",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.arriveEmployeeDate
                                    .minuteArriveLate > 0
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.arriveEmployeeDate
                                              .minuteArriveLate
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2740889943
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "right",
                          label: "Tác vụ",
                          width: "170",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-right": "10px" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            loading: scope.row.loadingSave,
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleArriveRowSave(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("button.save")))]
                                      ),
                                      scope.row.arriveEmployeeDate.arriveTime !=
                                        null && scope.row.showEdit
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "success",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleArriveUpdateRowMethod(
                                                    scope.$index,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("button.update"))
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "success",
                                                disabled: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("button.update"))
                                              ),
                                            ]
                                          ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1518200412
                        ),
                      }),
                    ],
                    1
                  ),
                  _vm.checkPermission(["attendanceEmployee_attendance_update"])
                    ? _c(
                        "div",
                        { staticStyle: { float: "right", margin: "15px 0" } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "button-bottom",
                              attrs: {
                                type: "success",
                                loading: _vm.loadingButtonSaveArriveDate,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleArriveManyRowSave()
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-circle-check" }),
                              _vm._v("\n          Lưu chấm công đến\n        "),
                            ]
                          ),
                          _c(
                            "el-dropdown",
                            { on: { command: _vm.handleCommandAction } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "button-bottom",
                                  attrs: { type: "success" },
                                },
                                [
                                  _vm._v("\n            Tác vụ\n            "),
                                  _c("i", {
                                    staticClass: "el-icon-caret-bottom",
                                  }),
                                ]
                              ),
                              _c(
                                "el-dropdown-menu",
                                { staticClass: "el-dropdown-menu-container" },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "exportDay" } },
                                    [_vm._v("Xuất theo ngày\n            ")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "exportMonth" } },
                                    [_vm._v("Xuất theo tháng\n            ")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "exportAll" } },
                                    [_vm._v("Xuất tổng hợp\n            ")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "exportMonthDetail" } },
                                    [
                                      _vm._v(
                                        "\n              Xuất file chi tiết\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.checkPermission(["attendanceEmployee_attendance_update"])
            ? _c(
                "el-tab-pane",
                { attrs: { label: "Chấm công về", name: "attendanceLeave" } },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingData,
                          expression: "loadingData",
                        },
                      ],
                      ref: "multipleTable",
                      attrs: {
                        "empty-text": _vm.textTableLeave,
                        "element-loading-text": _vm.$tableLoading,
                        "element-loading-spinner": "el-icon-loading",
                        "element-loading-background": "rgba(255,255,255, 0)",
                        "highlight-current-row": "",
                        data: _vm.responseLeaveList,
                        "cell-style": _vm.tableRowLeaveStyle,
                        "header-cell-style": _vm.tableHeaderColor,
                        "max-height": _vm.$tableMaxHeight,
                        border: "",
                      },
                      on: {
                        "selection-change": _vm.handleSelectionChangeLeave,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          fixed: "",
                          type: "selection",
                          align: "center",
                          width: "55",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "",
                          type: "index",
                          label: "STT",
                          width: "50",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "",
                          prop: "fullName",
                          label: "Họ và tên",
                          "min-width": "200",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.attendanceInfoEmployee
                                          .fullName
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2147710583
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "unit",
                          align: "center",
                          label: "Trạng thái đi làm",
                          "min-width": "100",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.status == true
                                    ? _c("span", [_vm._v("Đã chấm công")])
                                    : _c("span", [_vm._v("Chưa chấm công")]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1917436535
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "number",
                          align: "center",
                          "min-width": "80",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "header",
                              fn: function (scope) {
                                return [
                                  _c("span", [_vm._v("Đã về")]),
                                  _c("br"),
                                  _c("el-checkbox", {
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeAllLeave(scope.$index)
                                      },
                                    },
                                    model: {
                                      value: _vm.checkboxAllLeave,
                                      callback: function ($$v) {
                                        _vm.checkboxAllLeave = $$v
                                      },
                                      expression: "checkboxAllLeave",
                                    },
                                  }),
                                ]
                              },
                            },
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.arrive
                                    ? _c("el-checkbox", {
                                        on: {
                                          change: function ($event) {
                                            return _vm.checkRowLeave(scope.row)
                                          },
                                        },
                                        model: {
                                          value:
                                            scope.row.attendanceLeaveEmployee
                                              .leave,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.attendanceLeaveEmployee,
                                              "leave",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.attendanceLeaveEmployee.leave",
                                        },
                                      })
                                    : _c("el-checkbox", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value:
                                            scope.row.attendanceLeaveEmployee
                                              .leave,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.attendanceLeaveEmployee,
                                              "leave",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.attendanceLeaveEmployee.leave",
                                        },
                                      }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1406582576
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "Giờ về",
                          width: "132",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.arrive
                                    ? _c("el-time-picker", {
                                        staticStyle: { width: "85%" },
                                        attrs: {
                                          type: "time",
                                          "value-format": "HH:mm",
                                          format: "HH:mm",
                                          clearable: false,
                                          size: "mini",
                                          "picker-options": {
                                            selectableRange:
                                              "00:00:00 - 23:59:00",
                                          },
                                          placeholder: "Chọn",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.getTimeLeave(scope.row)
                                          },
                                        },
                                        model: {
                                          value:
                                            scope.row.attendanceLeaveEmployee
                                              .leaveTime,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.attendanceLeaveEmployee,
                                              "leaveTime",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.attendanceLeaveEmployee.leaveTime",
                                        },
                                      })
                                    : _c("el-time-picker", {
                                        staticStyle: { width: "85%" },
                                        attrs: {
                                          disabled: "",
                                          type: "time",
                                          "value-format": "HH:mm",
                                          format: "HH:mm",
                                          clearable: false,
                                          size: "mini",
                                          "picker-options": {
                                            selectableRange:
                                              "00:00:00 - 23:59:00",
                                          },
                                          placeholder: "Chọn",
                                        },
                                        model: {
                                          value:
                                            scope.row.attendanceLeaveEmployee
                                              .leaveTime,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.attendanceLeaveEmployee,
                                              "leaveTime",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.attendanceLeaveEmployee.leaveTime",
                                        },
                                      }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2852429468
                        ),
                      }),
                      _c("el-table-column", {
                        staticClass: "second-title",
                        attrs: {
                          label: "Về sớm(Phút)",
                          width: "130",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.attendanceLeaveEmployee
                                    .minuteLeaveSoon > 0
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.attendanceLeaveEmployee
                                              .minuteLeaveSoon
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          404946839
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          width: "70",
                          label: "Trông muộn",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-checkbox", {
                                    model: {
                                      value:
                                        scope.row.attendanceLeaveEmployee
                                          .takeCareLate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          scope.row.attendanceLeaveEmployee,
                                          "takeCareLate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "scope.row.attendanceLeaveEmployee.takeCareLate",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3311513582
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Tác vụ",
                          fixed: "right",
                          width: "170",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-right": "10px" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            disabled: !scope.row.arrive,
                                            loading: scope.row.loadingSave,
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleLeaveRowSave(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("button.save")))]
                                      ),
                                      scope.row.attendanceLeaveEmployee
                                        .leaveTime != null &&
                                      scope.row.attendanceLeaveEmployee.leave &&
                                      scope.row.showEdit
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "success",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleLeaveUpdateRowMethod(
                                                    scope.$index,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("button.update"))
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "success",
                                                disabled: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("button.update"))
                                              ),
                                            ]
                                          ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          745332690
                        ),
                      }),
                    ],
                    1
                  ),
                  _vm.checkPermission(["attendanceEmployee_attendance_update"])
                    ? _c(
                        "div",
                        { staticStyle: { float: "right", margin: "15px 0" } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "button-bottom",
                              attrs: {
                                type: "success",
                                loading: _vm.loadingButtonSaveLeaveDate,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleLeaveManyRowSave()
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-circle-check" }),
                              _vm._v("\n          Lưu chấm công về\n        "),
                            ]
                          ),
                          _c(
                            "el-dropdown",
                            { on: { command: _vm.handleCommandAction } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "button-bottom",
                                  attrs: { type: "success" },
                                },
                                [
                                  _vm._v("\n            Tác vụ\n            "),
                                  _c("i", {
                                    staticClass: "el-icon-caret-bottom",
                                  }),
                                ]
                              ),
                              _c(
                                "el-dropdown-menu",
                                { staticClass: "el-dropdown-menu-container" },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "exportDay" } },
                                    [_vm._v("Xuất theo ngày\n            ")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "exportMonth" } },
                                    [_vm._v("Xuất theo tháng\n            ")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "exportAll" } },
                                    [_vm._v("Xuất tổng hợp\n            ")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "exportMonthDetail" } },
                                    [
                                      _vm._v(
                                        "\n              Xuất file chi tiết\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-tab-pane",
            { attrs: { label: "Chấm ăn", name: "attendanceEat" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingData,
                      expression: "loadingData",
                    },
                  ],
                  ref: "multipleTable",
                  attrs: {
                    "empty-text": _vm.textTableEat,
                    "element-loading-text": _vm.$tableLoading,
                    "element-loading-spinner": "el-icon-loading",
                    "element-loading-background": "rgba(255,255,255, 0)",
                    "highlight-current-row": "",
                    data: _vm.responseEatList,
                    "cell-style": _vm.tableRowStyleEat,
                    "header-cell-style": _vm.tableHeaderColor,
                    "max-height": _vm.$tableMaxHeight,
                    border: "",
                  },
                  on: { "selection-change": _vm.handleSelectionChangeEat },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      fixed: "",
                      type: "selection",
                      align: "center",
                      width: "55",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "",
                      type: "index",
                      label: "STT",
                      width: "50",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "",
                      prop: "name",
                      label: "Họ và tên",
                      "min-width": "170",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.attendanceInfoEmployee.fullName
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "unit",
                      align: "center",
                      label: "Chấm công ăn",
                      "min-width": "130",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.attendanceEatEmployee.eat
                              ? _c("span", [_vm._v("Đã chấm ăn")])
                              : _c("span", [_vm._v("Chưa chấm ăn")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "unit",
                        align: "center",
                        label: "Trạng thái đi làm",
                        "min-width": "100",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "Sáng", width: "70", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return scope.row.arriveEmployeeDate != null
                                  ? [
                                      scope.row.arriveEmployeeDate.morning
                                        ? _c(
                                            "span",
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "dark",
                                                    content: "Đi làm",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-circle-check",
                                                    staticStyle: {
                                                      color: "#409eff",
                                                      "font-size": "18px",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : scope.row.arriveEmployeeDate
                                            .morningYes
                                        ? _c(
                                            "span",
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "dark",
                                                    content: "Nghỉ có phép",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-circle-close",
                                                    staticStyle: {
                                                      color: "#f56c6c",
                                                      "font-size": "18px",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : scope.row.arriveEmployeeDate.morningNo
                                        ? _c(
                                            "span",
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "dark",
                                                    content: "Nghỉ không phép",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-error",
                                                    staticStyle: {
                                                      color: "#f56c6c",
                                                      "font-size": "18px",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  : undefined
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Chiều", width: "70", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return scope.row.arriveEmployeeDate != null
                                  ? [
                                      scope.row.arriveEmployeeDate.afternoon
                                        ? _c(
                                            "span",
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "dark",
                                                    content: "Đi làm",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-circle-check",
                                                    staticStyle: {
                                                      color: "#409eff",
                                                      "font-size": "18px",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : scope.row.arriveEmployeeDate
                                            .afternoonYes
                                        ? _c(
                                            "span",
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "dark",
                                                    content: "Nghỉ có phép",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-circle-close",
                                                    staticStyle: {
                                                      color: "#f56c6c",
                                                      "font-size": "18px",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : scope.row.arriveEmployeeDate
                                            .afternoonNo
                                        ? _c(
                                            "span",
                                            { staticClass: "absent-no" },
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "dark",
                                                    content: "Nghỉ không phép",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-error",
                                                    staticStyle: {
                                                      color: "#f56c6c",
                                                      "font-size": "18px",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  : undefined
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Tối", width: "70", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return scope.row.arriveEmployeeDate != null
                                  ? [
                                      scope.row.arriveEmployeeDate.evening
                                        ? _c(
                                            "span",
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "dark",
                                                    content: "Đi làm",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-circle-check",
                                                    staticStyle: {
                                                      color: "#409eff",
                                                      "font-size": "18px",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : scope.row.arriveEmployeeDate
                                            .eveningYes
                                        ? _c(
                                            "span",
                                            { staticClass: "absent-yes" },
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "dark",
                                                    content: "Nghỉ có phép",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-circle-close",
                                                    staticStyle: {
                                                      color: "#f56c6c",
                                                      "font-size": "18px",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : scope.row.arriveEmployeeDate.eveningNo
                                        ? _c(
                                            "span",
                                            { staticClass: "absent-no" },
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "dark",
                                                    content: "Nghỉ không phép",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-error",
                                                    staticStyle: {
                                                      color: "#f56c6c",
                                                      "font-size": "18px",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  : undefined
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                  _c("el-table-column", {
                    attrs: {
                      prop: "number",
                      align: "center",
                      "min-width": "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v("Sáng")]),
                            _c("br"),
                            _c("el-checkbox", {
                              on: {
                                change: function ($event) {
                                  return _vm.changeCheckboxAllEat(
                                    "breakfast",
                                    scope.row
                                  )
                                },
                              },
                              model: {
                                value: _vm.checkboxAllEatBreakfast,
                                callback: function ($$v) {
                                  _vm.checkboxAllEatBreakfast = $$v
                                },
                                expression: "checkboxAllEatBreakfast",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-checkbox", {
                              attrs: {
                                disabled: scope.row.attendanceEmployeeConfig
                                  .breakfast
                                  ? false
                                  : true,
                              },
                              model: {
                                value:
                                  scope.row.attendanceEatEmployee.breakfast,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row.attendanceEatEmployee,
                                    "breakfast",
                                    $$v
                                  )
                                },
                                expression:
                                  "scope.row.attendanceEatEmployee.breakfast",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "number",
                      align: "center",
                      "min-width": "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v("Trưa")]),
                            _c("br"),
                            _c("el-checkbox", {
                              on: {
                                change: function ($event) {
                                  return _vm.changeCheckboxAllEat(
                                    "lunch",
                                    scope.row
                                  )
                                },
                              },
                              model: {
                                value: _vm.checkboxAllEatLunch,
                                callback: function ($$v) {
                                  _vm.checkboxAllEatLunch = $$v
                                },
                                expression: "checkboxAllEatLunch",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-checkbox", {
                              attrs: {
                                disabled: scope.row.attendanceEmployeeConfig
                                  .lunch
                                  ? false
                                  : true,
                              },
                              model: {
                                value: scope.row.attendanceEatEmployee.lunch,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row.attendanceEatEmployee,
                                    "lunch",
                                    $$v
                                  )
                                },
                                expression:
                                  "scope.row.attendanceEatEmployee.lunch",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "number",
                      align: "center",
                      "min-width": "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v("Tối")]),
                            _c("br"),
                            _c("el-checkbox", {
                              on: {
                                change: function ($event) {
                                  return _vm.changeCheckboxAllEat(
                                    "dinner",
                                    scope.row
                                  )
                                },
                              },
                              model: {
                                value: _vm.checkboxAllEatDinner,
                                callback: function ($$v) {
                                  _vm.checkboxAllEatDinner = $$v
                                },
                                expression: "checkboxAllEatDinner",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-checkbox", {
                              attrs: {
                                disabled: scope.row.attendanceEmployeeConfig
                                  .dinner
                                  ? false
                                  : true,
                              },
                              model: {
                                value: scope.row.attendanceEatEmployee.dinner,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row.attendanceEatEmployee,
                                    "dinner",
                                    $$v
                                  )
                                },
                                expression:
                                  "scope.row.attendanceEatEmployee.dinner",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.checkPermission(["attendanceEmployee_attendance_update"])
                    ? _c("el-table-column", {
                        attrs: {
                          label: "Tác vụ",
                          fixed: "right",
                          width: "200",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  ((scope.row.attendanceEmployeeConfig
                                    .breakfast &&
                                    scope.row.attendanceEatEmployee
                                      .breakfast) ||
                                    !scope.row.attendanceEmployeeConfig
                                      .breakfast) &&
                                  ((scope.row.attendanceEmployeeConfig.lunch &&
                                    scope.row.attendanceEatEmployee.lunch) ||
                                    !scope.row.attendanceEmployeeConfig
                                      .lunch) &&
                                  ((scope.row.attendanceEmployeeConfig.dinner &&
                                    scope.row.attendanceEatEmployee.dinner) ||
                                    !scope.row.attendanceEmployeeConfig.dinner)
                                    ? _c(
                                        "el-button",
                                        {
                                          staticStyle: { width: "94px" },
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleEatRowCheckboxAll(
                                                scope.$index,
                                                scope.row,
                                                false
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Bỏ chọn\n            ")]
                                      )
                                    : _c(
                                        "el-button",
                                        {
                                          staticStyle: { width: "94px" },
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleEatRowCheckboxAll(
                                                scope.$index,
                                                scope.row,
                                                true
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Chọn tất cả\n            ")]
                                      ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        loading: scope.row.loadingSave,
                                        size: "mini",
                                        type: "success",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleEatRowSave(
                                            scope.$index,
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("button.save")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          308691711
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm.checkPermission(["attendanceEmployee_attendance_update"])
                ? _c(
                    "div",
                    { staticStyle: { float: "right", margin: "15px 0" } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "button-bottom",
                          attrs: {
                            type: "success",
                            loading: _vm.loadingButtonSaveEatDate,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleEatManyRowSave()
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-circle-check" }),
                          _vm._v("\n          Lưu chấm công ăn\n        "),
                        ]
                      ),
                      _c(
                        "el-dropdown",
                        { on: { command: _vm.handleCommandAction } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "button-bottom",
                              attrs: { type: "success" },
                            },
                            [
                              _vm._v("\n            Tác vụ\n            "),
                              _c("i", { staticClass: "el-icon-caret-bottom" }),
                            ]
                          ),
                          _c(
                            "el-dropdown-menu",
                            { staticClass: "el-dropdown-menu-container" },
                            [
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: "exportDay" } },
                                [_vm._v("Xuất theo ngày\n            ")]
                              ),
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: "exportMonth" } },
                                [_vm._v("Xuất theo tháng\n            ")]
                              ),
                              _c(
                                "el-dropdown-item",
                                { attrs: { command: "exportAll" } },
                                [_vm._v("Xuất tổng hợp\n            ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("CheckInformationAIDialog", {
        ref: "CheckInformationAIDialog",
        attrs: { dialogVisible: _vm.isOpenCheckInformationAIDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeCheckInformationAIDialog()
          },
        },
      }),
      _c("AttendanceArriveEmployeeUpdate", {
        ref: "AttendanceArriveEmployeeUpdate",
        attrs: { dialogVisible: _vm.showDialogUpdateArrive },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeDialogUpdateArriveMethod()
          },
        },
      }),
      _c("AttendanceLeaveEmployeeUpdate", {
        ref: "AttendanceLeaveEmployeeUpdate",
        attrs: { dialogVisible: _vm.showDialogUpdateLeave },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeDialogUpdateLeaveMethod()
          },
        },
      }),
      _c("AttendanceView", {
        ref: "AttendanceView",
        attrs: { dialogVisible: _vm.showDialogViewDetailDate },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeDialogViewDetailDateMethod()
          },
        },
      }),
      _c("CreateAttendanceEmployeeCustomExcel", {
        ref: "CreateAttendanceEmployeeCustomExcel",
        attrs: { dialogVisible: _vm.showDialogCreateAttendanceKidCustomExcel },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeDialogAttendanceKidCustomExcel()
          },
        },
      }),
      _c("CreateAttendanceEmployeeDetailExcel", {
        attrs: {
          isOpenCreateAttendanceEmployeeDetailExcel:
            _vm.isOpenCreateAttendanceEmployeeDetailExcel,
        },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeDialogAttendanceKidDetailExcel()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }